import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authApi } from '../../api';
import '../Login/Login.css';

const RecuperarPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);
    try {
      const data = await authApi.recuperarPassword(email);
      setSuccess(data.message || 'Si el correo existe, recibirás un enlace.');
    } catch (err) {
      setError(err.message || 'Error al enviar el correo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-card__logo">
          <img src={process.env.PUBLIC_URL + '/cash_logo_color-06.png'} alt="Cash Sol SAC" />
        </div>
        <h2>Recuperar contraseña</h2>
        <p className="auth-card__sub">
          Ingresa tu correo y te enviaremos un enlace para restablecer tu contraseña.
        </p>

        {error && <div className="auth-alert auth-alert--error">{error}</div>}
        {success && <div className="auth-alert auth-alert--success">{success}</div>}

        {!success && (
          <form onSubmit={handleSubmit} className="auth-form">
            <div className="auth-field">
              <label>Correo electrónico</label>
              <div className="auth-input-wrap">
                <i className="fa-solid fa-envelope"></i>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="correo@email.com"
                  required
                />
              </div>
            </div>

            <button type="submit" className="btn-primary auth-btn" disabled={loading}>
              {loading ? <span className="spinner-sm"></span> : (
                <><i className="fa-solid fa-paper-plane"></i> Enviar enlace</>
              )}
            </button>
          </form>
        )}

        <p className="auth-card__bottom">
          <Link to="/login" className="auth-link">
            <i className="fa-solid fa-arrow-left"></i> Volver al login
          </Link>
        </p>
      </div>
    </div>
  );
};

export default RecuperarPassword;
